// src/pages/faq.js
import React, { useState } from 'react';
import '../components/faq.css';


const faqs = [
  { question: "What's the point of this website?", answer: "\u00A0\ It's not always the case where everyone in a group has each others contact info, or maybe you just met someone you hit it off with that you want to have join your outing. It can also be tough keeping everyone in a group all on the same page regarding event logistics. This non-invasive tool fills that void. No need for exchanging phone numbers or compartmentalized communication....you can keep everyone on the same page regardless of whether they share contact info"}, 
  { question: "How does this even work?", answer:
               "\n\u2022\u00A0\u00A0\ A membership is not required, but if you want to create events you'll need one - it's FREEEEEEE tho\n" +
               "\u2022\u00A0\u00A0\ Once a member, you'll be able to create your event(s)\n" +
               "\u2022\u00A0\u00A0\ To join an event, a membership is NOT required. Simply enter both the virtual room code (VRC) and passphrase to view the event\n" +
               "\u2022\u00A0\u00A0\ VRC's are generated automatically once an event is created\n" +
               "\u2022\u00A0\u00A0\ Passphrases are created by the event host and is unique to each person\n" +
               "\u2022\u00A0\u00A0\ Think of the VRC and passphrase as a username and login to get into a site, but instead it's controlled by the host\n"},
  { question: "What's up with the photo of the month?", answer: "\u00A0\ If you're enjoying this platform send us a photo from your event. We will randomly select a photo to put on the main page for all to seeeee!" },
  { question: "Do you offer customer support?", answer: "Absolutely! Send us an email to info@screentoscene.com" },
];

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">FAQ</h1>
      <h2 className="faq-subtitle">Popular Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, i) => (
          <div key={i} className="faq-item">
            <div className="faq-question" onClick={() => toggle(i)}>
              <span className="faq-icon">{activeIndex === i ? '−' : '+'}</span>
              {faq.question}
            </div>
            {activeIndex === i && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
